module.exports = new __parcel__URL__("partner_1.2a8817c9.png").toString();